import React from 'react';
import { signInWithPopup, GoogleAuthProvider } from 'firebase/auth';
import { auth } from '../firebase';
import { isAuthorized } from '../utils/auth';
import Waitlist from './Waitlist';
import './Login.css';

const Login = ({ onLogin }) => {
  const signInWithGoogle = async () => {
    const provider = new GoogleAuthProvider();
    try {
      const result = await signInWithPopup(auth, provider);
      
      // Validate email in frontend
      if (!isAuthorized(result.user.email)) {
        await auth.signOut();
        alert('Access denied. Please use an authorized email address.');
        return;
      }
      
      onLogin(result.user);
    } catch (error) {
      console.error('Error signing in with Google:', error);
    }
  };

  return (
    <div className="login-content">
      <h1>Visualize AI</h1>
      <p>Learning designed around you.</p>
      
      <div className="auth-section">
        <button onClick={signInWithGoogle} className="google-button">
          <img src="https://upload.wikimedia.org/wikipedia/commons/thumb/c/c1/Google_%22G%22_logo.svg/2048px-Google_%22G%22_logo.svg.png" alt="Google" />
          Continue with Google
        </button>
        <div className="divider">
          <span>or</span>
        </div>
        <Waitlist />
      </div>
    </div>
  );
};

export default Login;
